<template>
    <div class="wrap">
        <div class="signup">
            <h3>접수 및 진료 취소</h3>
            <ul class="signup-list">
                <li class="clearfix">
                    <label for="hosp-id">선택 </label>
                    <div class="inpt">
                        <select name="cancel-id" id="cancel-id" @change="onChange($event)" v-validate="'required'">
                            <option v-for="row in cancelCodes" :value="row.idx" :key="row.idx">{{ row.subject }}</option>
                        </select>
                        <p style="color:red" v-show="errors.has('cancel-id')" class="error-msg">메세지 입력은 필수 입니다.</p>
                    </div>
                </li>    
                <li class="clearfix">
                    <label for="cancel-content">내용</label>
                    <div class="inpt">
                        <input type="text" name="cancel-content" id="cancel-content" v-model="sendMessage" ref="cancel_content_input" :disabled="is_sendMessage">
                    </div>
                </li>
             </ul>  
        </div>
        <button class="user-info-btn" @click.prevent="sendCancel()" :disabled="!is_click">확인/전송</button>
    </div>
</template>

<script>
import moment from 'moment-timezone';
import URLS from '@/lib/urls'  
import {STATUS_CODE, getConstName} from '@/lib/constants'

export default {
    name: 'consult-cancel',
    props: ['note', 'account', 'status', 'is_admin'],
    data() {
        return {
            cancelCodes: [],
            sendMessage: '',
            is_sendMessage: true,
            is_click: true
        }
    },
    methods: {
        
        onChange(event) {
            if(event.target.value == 9) {
                this.sendMessage = '';
                this.is_sendMessage = false;
                setTimeout(() => {
                    this.$refs.cancel_content_input.focus();
                }, 10);
            } else {
                for(var i=0; i<this.cancelCodes.length; i++) {
                    if(this.cancelCodes[i].idx == event.target.value) {
                        this.is_sendMessage = true;
                        this.sendMessage = this.cancelCodes[i].subject;
                    } 
                }  
            }

        },
        async sendCancel() {
            if(!this.sendMessage || this.sendMessage.trim()=='') {
                alert('내용을 입력하셔야 합니다.');
                this.sendMessage = this.sendMessage.trim();
                this.$refs.cancel_content_input.focus();
                return;
            }

            if(!confirm("정말 진료 취소 하시겠습니까?")){
                return false;    
            }

            this.is_click = false;

            // console.log(this.account.dr_id)
            // console.log(this.account.dr_name)
            // console.log(this.note.dr_id)
            // console.log(this.note.dr_name)
            // console.log(this.is_admin)

            let params = {
                status: 9
            };

            let {data} = await this.axios.post(`consult_note/consult_status/${this.note.note_id}`, params)

            if (data.status === STATUS_CODE.OK) {

                let reply_push = this.sendMessage;
                let post_data = {
                    push_title: `전화상담 알림\n(${this.note.dr_name})`, 
                    push_msg: '[취소]' + reply_push, 
                    push_dr_id:this.is_admin == 1 ? this.account.dr_id : this.note.dr_id, 
                    push_uid:this.note.uid,
                    push_consult_type:9,
                    push_send_type:6
                } 
                
                let {data} = await this.axios.post(`consult_note/${this.note.note_id}/push`, post_data);
                alert('전화상담이 취소되어 환자에게 알림이 전송되었습니다.');
                this.is_click = true;
                await this.$emit('setCancel', 9);


            } else {
                alert('에러: ' + data.msg);
                this.is_click = true;
                return;
            }
        },
        async cancel_list () {  //전문 진료 분야 가져오기 20190411 kjw
            // this.$log.debug('cancel_list',this.status)
            let routerName = '';
            if(this.status < 2) routerName = 'appdata/code/15';
            else routerName = 'appdata/code/16';
    
            let {data: {resp}} = await this.axios.get(routerName)
            this.cancelCodes = resp;
            this.sendMessage = this.cancelCodes[0].subject;
        },
    },
    async mounted() {
        //this.cancel = this.cancels;
        await this.cancel_list();
    },
}
</script>

<style scoped>
    .wrap {
        width: 100%;
        height: 50%;
        max-width: 370px;
        max-height: 300px;
    }

    .wrap h3 {
        color: #474747;
        text-align: center;
        letter-spacing: -.5px;
        margin-bottom: 20px;
        font: 400 20px 'Noto Sans KR', sans-serif;
    }

    .signup {
        width: 100%;
        max-width: 390px;
        height: 100%;
        max-height: 640px;
        padding: 20px;
        position: relative;
        background-color: #fff;
        border: 1px solid #eee;
        box-sizing: border-box;
        margin: 10px auto 10px;
        overflow: auto;
    }

    .signup h2 {font: 400 14px 'Noto Sans KR', sans-serif;}
    .signup-list {margin: 0;}
    .signup-list li {margin-bottom: 10px;}

    .signup-list li > label {
        width: 40px;
        height: 30px;
        position: relative;
        font: 400 14px/30px 'Noto Sans KR', sans-serif;
    }

    .signup-list li > label em {
        color: #ff316d;
        position: absolute;
        top: 5px;
        margin-left: 5px;
    }

    .signup-list li > label,
    .signup-list li > input,
    .signup-list li > div,
    .signup-list li > select {float: left;}

    .signup-list input,
    .signup-list select {
        height: 30px;
        padding: 0 10px;
        box-sizing: border-box;
        border: 1px solid #d2d2d2;
    }

    .signup-list .cancel-chk {
        width: 120px; 
        height: 15px;
        box-sizing: border-box;
        border: 0px solid #d2d2d2;
    }

    .signup-list select {font: 400 12px 'Noto Sans KR', sans-serif;}
    
    #cancel-name, #cancel-content{
        width: 305px; 
        margin: 0px;
    }

    #cancel-price {
        width: 240px; 
        text-align: right;
        margin: 0 49px 5px 40px;
        font: 400 12px 'Noto Sans KR', sans-serif;  
    }
    #cancel-price-mdtalk {
        width: 240px; 
        text-align: right;
        margin: 0 0 5px 25px;
        font: 400 12px 'Noto Sans KR', sans-serif;  
    }

    #cancel-price-text{
        width: 605px; 
        margin: 0 0 5px 14px;
        font: 400 12px 'Noto Sans KR', sans-serif;  
    }

    /* #specialty-id, #hosp-name {
        width: 380px;
        padding: 0 15px;
        font: 400 14px 'Noto Sans KR', sans-serif;
        background: url(../../assets/home/select.png) 95% no-repeat;
    } */

    #specialty-id {
        width: 240px;
        padding: 0 15px;
        font: 400 12px 'Noto Sans KR', sans-serif;
        background: url(../../assets/home/select.png) 95% no-repeat;
    }

    #hosp-name {
        width: 240px;
        padding: 0 15px;
        margin: 0 60px 0 0;        
        font: 400 12px 'Noto Sans KR', sans-serif;
        background: url(../../assets/home/select.png) 95% no-repeat;
    }

    #status-id {
        width: 240px;
        margin: 0 60px 0 0;
        padding: 0 15px;
        font: 400 12px 'Noto Sans KR', sans-serif;
        background: url(../../assets/home/select.png) 95% no-repeat;
    }

    #inspection-id{
        width: 240px;
        padding: 0 15px;
        font: 400 12px 'Noto Sans KR', sans-serif;
        background: url(../../assets/home/select.png) 95% no-repeat;
    }

    #signup-name, #signup-category{
        width: 598px;
        height: 50px;
        border: 1px solid #d2d2d2;
        font: 500 12px/50px 'Noto Sans KR', sans-serif;
    }

    #signup-start, #signup-end{
        width: 329px;
        height: 40px;
        border: 1px solid #d2d2d2;
    }

    #main-area, #cancel-area, #consult-area, #mypage-area {
        height: 25px;
        margin: 0 5px 10px 10px;
        cursor: pointer;
    }

    #cancel-url {
        width: 450px;
        margin: 0 0 5px 10px;
        font: 400 12px 'Noto Sans KR', sans-serif;  
    }

    /* 에러메세지 */
    .error-msg {line-height: 12px; color: #746ce5 !important; font: 400 12px/30px 'Noto Sans KR', sans-serif;}

    .user-info-btn {
        display:block;
        width: 80px;
        padding: 5px;
        cursor: pointer;
        position: relative;
        box-sizing: border-box;
        margin: 10px auto 10px;    
        margin-top: 40px; 
        font: 400 12px 'Noto Sans KR', sans-serif;   
    }

    .img-area{
        width: 660px;
        padding:0px 10px;
        background:#f5f6fa;
        /* cursor: pointer; */
    }

    .add-interior-thumb {font-size: 0;}
    .add-interior-thumb span {
        float: left;
        width: 300px;
        height: 60px;
        margin: 10px;
    }

    .add-interior-thumb-detail span {
        float: left;
        width: 80px;
        height: 60px;
        margin: 10px;
    }

    .add-interior-thumb-upload {
        display: inline-block;
        width: 40px;
        height: 40px;
        border: none;
        position: relative;
        border: 1px solid #999;
        background-color: transparent;
        cursor: pointer;
    }

    .add-interior-thumb-upload span {
        display: block;
        width: 35px;
        height: 35px;
        color: #999;
        position: absolute;
        text-align: center;
        left: 47%;
        top: 35%;
        border-radius: 50%;
        border: 1px solid #999;
        transform: translate(-50%, -50%);
        font: 400 24px/35px 'Noto Sans KR', sans-serif;
    }

    .add-interior-thumb-upload-detail {
        display: inline-block;
        width: 60px;
        height: 60px;
        border: none;
        position: relative;
        border: 1px solid #999;
        background-color: transparent;
        cursor: pointer;
    }

    .add-interior-thumb-upload-detail span {
        display: block;
        width: 35px;
        height: 35px;
        color: #999;
        position: absolute;
        text-align: center;
        left: 40%;
        top: 30%;
        border-radius: 50%;
        border: 1px solid #999;
        transform: translate(-50%, -50%);
        font: 400 24px/35px 'Noto Sans KR', sans-serif;
    }

    /** 
     * 이미지 업로드
     */
    .thumbnail {
        /*padding:4px;*/
        border: 1px solid #ddd;
        display: inline-block;
        float:left;
        overflow: hidden;
        position:relative;
        line-height: 0;
      }

    .thumbnail img {
        width: 100%;
        height: 100%;
    }
    .thumbnail .icon-remove {
        position: absolute;
        left: 0;
        top: 0;
    }

    .btn-group {
        width: 600px;
    }

    .btn-group .btn-radio {
        float: left;
        font-size: 0;
    }

    .btn-group .btn-radio > li {
        width: 230px;
        color: #aeafb3;
        display: inline-block;
        margin: 0;
    }

    .btn-group .btn-radio li > label {
        width: 210px;
        height: 30px;
        position: relative;
        font: 400 12px/40px 'Noto Sans KR', sans-serif;
    }

    .btn-group .btn-radio input[type="radio"] {
        display: none;
    }

    .btn-group .btn-radio input[type="radio"]:checked + .period-radio::before {
        border: 6px solid #736ee6;
    }

    .period-radio {
        display: block;
        text-indent: 25px;
        cursor: pointer;
        position: relative;
        font: 400 12px 'Noto Sans KR', sans-serif;
    }

    .period-radio::before {
        content: '';
        display: block;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: 1px solid #ddd;
        box-sizing: border-box;
        background-color: #fff;
        position: absolute;
        left: 0;
        top: 10px;
    }

    .btn-group .btn-cancel-chk {
        width: 100%;
        margin: 0;
        float: left;
        font-size: 0;
    }

    .btn-group .btn-cancel-chk > li {
        color: #aeafb3;
        display: inline-block;
        margin: 0;
    }

    .btn-group .btn-cancel-chk li > label {
        height: 25px;
        position: relative;
        cursor: pointer;
        font: 400 12px/25px 'Noto Sans KR', sans-serif;
        margin: 0;
    }

    .cancel-txt {
        color: #aeafb3;
        font: 400 12px/30px 'Noto Sans KR', sans-serif;
    }

    .cancel-txt li {
        color: #aeafb3;
        margin: 0 0 10px 10px;
        font: 400 12px/30px 'Noto Sans KR', sans-serif;
    }

    #cancel-id {
        width: 305px;
        padding: 0 10px;
        font: 400 12px 'Noto Sans KR', sans-serif;
        background: url(../../assets/home/select.png) 96% no-repeat;
    }
</style>